import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  user: {
    FullName: 'Full Name',
    FirstName: 'First Name',
    LastName: 'Last Name',
    Email: 'Email',
    OldPassword: 'Old Password',
    Password: 'Password',
    NewPassword: 'Password',
    ConfirmPassword: 'Confirm Password',
    Title: 'Title',
    Company: 'Company',
    SignUp: 'SIGN UP',
    SignIn: 'SIGN IN',
    ChangePassword: 'CHANGE PASSWORD',
    ForgotPassword: 'FORGOT PASSWORD',
    ResetPassword: 'RESET PASSWORD',
    forgotPassword: 'Forgot Password',
    changePassword: 'Change Password',
    Back: 'Back',
    Logout: 'Logout',
    Name: 'Name on card',
    ExpirationDate: 'Expiration date',
    CardNumber: 'Card Number',
    CVV: 'CVV'
  },
  menuData: [
    {
      index: '1',
      menuName: 'Dashboard',
      subMenu: [
        {
          index: 'dashboard',
          menuName: 'Home',
          icon: 'icon-home',
          disabled: false,
          // msg_count: 12,
          path: '/dashboard'
        }
      ]
    },
    {
      index: '2',
      menuName: 'Services',
      subMenu: [
        {
          index: 'malware',
          menuName: 'Android Malware Scan',
          icon: 'icon-mobile-malware',
          disabled: false,
          // msg_count: 1,
          path: '/malware'
        },
        {
          index: 'wifi',
          menuName: 'Android/iOS WiFi Scan',
          icon: 'icon-wf',
          disabled: false,
          path: '/wifi'
        },
        {
          index: 'junk',
          menuName: 'Android Junk Clean',
          icon: 'icon-junk',
          disabled: false,
          path: '/junk'
        },
        {
          index: 'whitelist',
          menuName: 'Whitelist',
          icon: 'icon-settings',
          disabled: false,
          path: '/whitelist',
          requiresWhitelist: true
        }
        // {
        //   index: 'url',
        //   menuName: 'URL Filtering',
        //   icon: 'icon-url-filtering',
        //   disabled: false,
        //   path: '/url'
        // },
        // {
        //   index: 'app',
        //   menuName: 'App Insight',
        //   icon: 'icon-app-insight',
        //   disabled: false,
        //   path: '/app'
        // }
      ]
    },
    {
      index: '3',
      menuName: 'Others',
      subMenu: [
        {
          index: 'settings',
          menuName: 'Settings',
          icon: 'icon-settings',
          path: '/settings',
          disabled: false
        },
        {
          index: 'support',
          menuName: 'Support',
          icon: 'icon-support',
          disabled: false,
          path: '/support'
        }
      ]
    }
  ],
  errMsg: {
    cardNameErr: "Please enter the cardholder's name",
    cardNumberErr1: 'Please enter your bank card number',
    cardNumberErr2: 'Please enter a valid bank card number！',
    cvvErr1: 'Please enter your CVV',
    cvvErr2: 'Please enter a valid CVV！',
    cardYearErr: 'Please choose year',
    cardMonthErr: 'Please choose month',
    emailErr1: 'Please enter your Email',
    emailErr2: 'Please enter a valid Email！',
    passwordErr1: 'Please enter your password',
    passwordErr2: 'Length 6-20',
    confirmPasswordErr1: 'Please enter your password again',
    confirmPasswordErr2: 'Two password inconsistencies!',
    oldPasswordErr: 'Please enter your old password',
    firstNameErr: 'Please enter your First Name',
    lastNameErr: 'Please enter your Last Name',
    titleErr: 'Please enter your title',
    companyErr: 'Please enter your company',
    err1: 'Incorrect information',
    err2: 'You did not sign in correctly , please try again.',
    err3: 'Sorry, can not find the email',
    tip1: 'Registration successful! You can now log in.',
    tip2: 'success, please check your email to reset password',
    noCard: 'You haven’t added any card yet.',
    startDateErr: 'Please enter the start date',
    endDateErr: 'Please enter the end date'
  },
  message: {
    edit: 'Edit',
    update: 'Update',
    confirm: 'Confirm',
    send: 'SEND',
    loading: 'loading...',
    wait: 'Please wait...',
    processing: 'Your payment is in processing,',
    addNewCard: 'Add New Card',
    switchLang: 'Change Language',
    myProfile: 'My Profile',
    aboutMe: 'About me',
    billing: 'My Billing Info',
    cardInformation: 'Card information',
    default: 'Set as Default',
    delete: 'Delete',
    updateInformation: 'Update Information',
    registerTip: 'By clicking on "SIGN UP", you agree with Trustlook’s',
    and: '&',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    setDefaultCard: 'Do you want to set this card as the default card?',
    deleteCard: 'Do you want to delete this card?',
    setSuccessfully: 'Set up successfully',
    deleteSuccessfully: 'Delete the card successfully',
    malwareUnsubscribe: "Do you want to unsubscribe from this 'Mobile Malware Detection'?",
    urlUnsubscribe: "Do you want to unsubscribe from this 'URL Filtering'?",
    appUnsubscribe: "Do you want to unsubscribe from this 'App Insight'?",
    unsubscribeSuccessfully: 'Unsubscribed successfully',
    UNSUBSCRIBE: 'UNSUBSCRIBE',
    CONFIRM: 'CONFIRM',
    CANCEL: 'CANCEL',
    ACTION: 'ACTION',
    DELETE: 'DELETE',
    switchSuccessfully: 'Switch Language Success',
    addSuccessfully: 'Add success',
    updateSuccessfully: 'Successfully updated'
  },
  name: {
    home: 'Home',
    malware: 'Mobile Malware Detection',
    url: 'URL Filtering',
    app: 'App Insight',
    wifi: 'WiFi Security Detection',
    reportDetail: 'APP Insight Detail',
    payment: 'Payment',
    settings: 'Settings',
    support: 'Support'
  },
  dashboard: {
    totalApi: 'Total API Calls:',
    quotaApi: 'Monthly API Quota:',
    monthApi: 'Consumed API Calls:',
    malwareApi: 'Malware API Calls:',
    billingCycleStartDate: 'Billing Cycle Start:',
    billingCycleEndDate: 'Billing Cycle End:',
    daily: 'Daily Bar Chart',
    weekly: 'Weekly Bar Chart',
    monthly: 'Monthly Bar Chart',
    apiCalls: 'API Calls',
    Malware: 'Malware',
    day: '1 day',
    week: '1 week',
    month: '1 month',
    malwareList: 'Malware List',
    urlList: 'URL filtering List',
    appList: 'App Insights List',
    noData: 'No Data',
    licenseKey: 'License Key:',
    packageName: 'Package Name:',
    yourLicense: 'Your License Key is:',
    noService: 'You don’t have any services.',
    bindMessage1:
      'Prevent third party abusement by binding key to package name. Contact us to update already bound package name.',
    bindMessage2: 'It takes up to 24 hours for package name binding to be effective',
    generateKey: 'Generate a new license key:',
    generateKeyLimit: '* If you need more than 20 keys, please contact us.',
    enableWifi: 'Enable Wifi security SDK',
    wifiSecuritySDK: 'Wifi security SDK:',
    invoice: 'Invoice:',
    deletedLicenseKeys: 'Deleted License Keys'
  },
  service: {
    malwareService: 'Malware Detection Service',
    urlService: 'URL Filtering Service',
    appService: 'Android Dynamic & Static Analysis Report Service',
    searchtxt1: 'Please enter apk file md5 hash',
    searchtxt2: 'Please enter a URL or domain',
    choose: 'Please display "Powered by Trustlook"',
    priceCompute: 'Price is computed at the end of billing cycle based on usage',
    screenshot: 'Example Usage',
    apiLevel: 'on your scan screen if there is any',
    malwareLevel: 'Malware List Level',
    urlLevel: 'URL Filtering List Level',
    monthly: 'monthly',
    one: 'One Time Package',
    select: 'SELECT',
    subscribe: 'SUBSCRIBE',
    download: 'DOWNLOAD',
    unsubscribe: 'UNSUBSCRIBE',
    each: 'Each apk will consume approximately 15 minutes ( based on the size of the file )',
    upload: 'Upload',
    report: 'report',
    apkLevel: 'APK Files Level',
    max: '(up to 128M)',
    freetip: 'During the free trial, users can upload one APK file at a time.',
    errType: 'Error uploading file type'
  },
  wifi: {
    wifiService: 'Android/iOS WiFi Security Scan',
    help: 'Detect following Wifi security threats',
    ARP: 'ARP spoofing',
    DNS: 'DNS cheating',
    SSL: 'SSL Stripping & Splitting',
    Weak: 'Weak password authentication',
    Device: 'Network devices scan',
    free: 'Subscribe',
    desc1: 'Available with malware detection subscription',
    desc2: 'Consume same quota from subscription',
    desc3: 'Bind key with package name on dashboard',
    desc4: 'Then enable Wifi Security SDK to use',
    desc5: 'Available on Android and iOS'
  },
  junk: {
    junkService: 'Junk Clean & Similar Photoes Detection',
    func1: 'APK junk clean',
    func2: 'Cache junk clean',
    func3: 'Log and tmp file junk clean',
    func4: 'Ad junk clean',
    func5: 'Residual junk clean',
    func6: 'Photo, screenshot, video, audio, document, thumbnail scan',
    func7: 'Smiliar photo scan',
    free: 'Subscribe',
    desc1: 'Available with malware detection subscription',
    desc2: 'Consume same quota from subscription',
    desc3: 'Junk clean',
    desc4: 'Similar photo scan',
    desc5: 'Please bind key with package name'
  },
  payment: {
    pay: 'Pay for the service',
    payType: 'Pay type',
    result: 'Result',
    enterInformation: 'Enter your card information',
    paySuccessfully: 'Payment Successful',
    payTip1: 'Your can now continue using our security service',
    payTip2: 'An email has been sent to you with order receipt, please check your inbox.'
  },
  support: [
    {
      name: 'Mobile Malware Detection',
      subMenu: [
        {
          title: 'Android SDK & User Manual',
          url: 'https://trustlook.s3.us-west-1.amazonaws.com/saas/trustlook_cloudscan_sdk.zip'
        }
        // {
        //   title: 'RESTful API User Manual',
        //   url: 'javascript:void(0);'
        // }
      ]
    },
    {
      name: 'Junk Clean',
      subMenu: [
        {
          title: 'Android SDK & User Manual',
          url: 'https://trustlook.s3.us-west-1.amazonaws.com/saas/trustlook_clean_sdk.zip'
        }
      ]
    },
    {
      name: 'WIFI Security',
      subMenu: [
        {
          title: 'Android/iOS SDK & User Manual',
          url: 'https://trustlook.s3.us-west-1.amazonaws.com/saas/trustlook_wifiscan_sdk.zip'
        }
      ]
    },
    {
      name: 'URL Filtering',
      subMenu: [
        // {
        //   title: 'SDK & User Manual',
        //   url: 'javascript:void(0);'
        // },
        {
          title: 'RESTful API User Manual',
          url:
            'https://trustlook.s3.us-west-1.amazonaws.com/saas/Trustlook+URL+Filtering+REST+API+User+Guide.pdf'
        }
      ]
    }
    // {
    //   name: 'APP Insight',
    //   subMenu: [
    //     {
    //       title: 'RESTful API User Manual',
    //       url: 'javascript:void(0);'
    //     }
    //   ]
    // },
    // {
    //   name: 'PE Malware Detection',
    //   subMenu: [
    //     {
    //       title: 'SDK & User Manual',
    //       url: 'javascript:void(0);'
    //     }
    //   ]
    // },
    // {
    //   name: 'Ransomware Detection',
    //   subMenu: [
    //     {
    //       title: 'SDK & User Manual',
    //       url: 'javascript:void(0);'
    //     }
    //   ]
    // },
  ],
  footer: {
    business: 'Business:',
    technical: 'Technical:',
    // tip1: 'Last 12 months malware list will be prepared in 8 working hours after purchase.',
    // tip2: 'All download links include weekly update will be showed on the Home Page',
    tip1: 'For safety purpose, please bind your key with your package name',
    tip2: 'Please generate a license key for each of your package',
    tip3: 'Last 12 months URL list will be prepared in 8 working hours after purchase',
    tip4: 'All download links include weekly update will be showed on the Home Page',
    tip5: 'If you have more than 10000 android applications to be analyzed per month,',
    tip6: 'please contact us at ​bd@trustlook.com',
    tip7:
      'If you have more than 10000 android applications to be analyzed per month , please contact us at ​bd@trustlook.com',
    tip8: 'Make sure to bind a package name with the license key on Home page',
    tip9: 'Then enable Wifi Security SDK to use',
    development: 'Development Documents',
    information: 'Purchase information'
  },
  whitelist: {
    title: 'Whitelist Management',
    emptyMessage: 'Whitelist functionality will be available soon.',
    md5Title: 'MD5 Whitelist Query',
    appidTitle: 'AppID Whitelist Query',
    certTitle: 'Certificate SHA1 Whitelist Query',
    md5Placeholder: 'Enter MD5 hash',
    appidPlaceholder: 'Enter AppID (e.g., com.example.app)',
    certPlaceholder: 'Enter Certificate SHA1 hash',
    md5AddPlaceholder: 'Enter MD5 hash to add',
    appidAddPlaceholder: 'Enter AppID to add',
    certAddPlaceholder: 'Enter Certificate SHA1 hash to add',
    query: 'Query',
    querying: 'Querying...',
    add: 'Add',
    adding: 'Adding...',
    status: 'Status',
    scan: 'Scan',
    lastUpdate: 'Last Update',
    scannedBy: 'Scanned By',
    score: 'Score',
    appid: 'AppID',
    certSha1: 'Certificate SHA1',
    updateDate: 'Update Date',
    myAdditions: 'My Whitelist Additions',
    noAdditions: 'You haven\'t added any items to the whitelist yet.'
  },
  ...enLocale
}

export default en



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js